import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcHumanWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 14,
		cy: 9,
		r: 4,
		fill: "#F1F6FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 17C6 15.3431 7.34315 14 9 14H19C20.6569 14 22 15.3431 22 17V22C22 22.5523 21.5523 23 21 23H7C6.44772 23 6 22.5523 6 22V17Z",
		fill: "#E2EBFE"
	})]
});
export default SvgIcHumanWhite;
